import React from "react";

import { Main } from "./Components"

import "./style.scss";

const PCSGeneratorView = () => {
    

    return (
        <div className="bpl-container">
            <Main />
        </div>
    );
};

export default React.forwardRef(PCSGeneratorView);
